import { type FC, useState } from "react";
import { useCookies } from "react-cookie";
import { Presentation } from "./Presentation";

const COOKIE_NAME = "mypage_message_show_banner";
const COOKIE_EXPIRATION_MS = 14 * 24 * 60 * 60 * 1000; // 14日間のミリ秒換算
const BIYO_APP_DL_URL = "https://relax-job.onelink.me/bIVn/jpeb063p";

export const MessageWebToAppBanner: FC = () => {
  const [isShow, setIsShow] = useState(true);
  const [, setCookie] = useCookies([COOKIE_NAME]);
  const handleOnClose = () => {
    setIsShow(false);
    setCookie(COOKIE_NAME, true, {
      path: "/",
      expires: new Date(Date.now() + COOKIE_EXPIRATION_MS),
    });
  };

  if (!isShow) return null;

  return (
    <Presentation
      href={BIYO_APP_DL_URL}
      gaAction="message__smart_app_banner_freetime"
      handleOnClose={handleOnClose}
    >
      アプリでスキマにパッと返信
    </Presentation>
  );
};
